import http from "@/service/http";
const comitente = {
  getComitente(id) {
    return new Promise((resolve, reject) => {
      http
        .get(`Empresa/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
};

export default comitente;
